import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4341f984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-header" }, "Choose a receiver", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_FriendCell = _resolveComponent("FriendCell")!
  const _component_CellGroup = _resolveComponent("CellGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      isCloseWindow: true,
      title: "Drop a gem"
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Searchbar, {
        modelValue: _ctx.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        placeholder: "Search a friend"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CellGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFriends, (friend) => {
            return (_openBlock(), _createBlock(_component_FriendCell, {
              key: friend.userId,
              friend: friend,
              isClickable: true,
              shouldDisplayUsername: true,
              onClick: ($event: any) => (_ctx.handleClickWithDelay(friend.userId))
            }, null, 8, ["friend", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}